import { Box, Divider } from "@chakra-ui/react";
import { PrefixId } from "features/Resources/Shared/models";
import { MeetingDayBucket, dayOffsetFromStart } from "features/Resources/Meeting/helpers";
import DayHeaderRow from "./DayHeaderRow";
import MeetingRow from "./MeetingRow";

interface DaySectionProps {
  day: MeetingDayBucket;
  onExpand: (prefixId: PrefixId) => void;
  startDate?: Date | string;
  isToday?: boolean;
  /** Include skipped meetings as rows (they are hidden otherwise). */
  showSkippedExpanded?: boolean;
}

export default function DaySection({ day, onExpand, startDate, isToday, showSkippedExpanded }: DaySectionProps) {
  const skipped = showSkippedExpanded ? day.skipped : [];
  const rows = [...day.scheduled, ...skipped];

  return (
    <Box w="100%">
      <DayHeaderRow
        date={day.date}
        dayNumber={startDate ? dayOffsetFromStart(day.date, startDate) : undefined}
        sessionCount={rows.length}
        isToday={isToday}
      />
      <Box px={4}>
        {rows.map((meeting, index) => (
          <Box key={meeting.id}>
            {index > 0 && <Divider borderColor="border.subtle" />}
            <MeetingRow meeting={meeting} onExpand={onExpand} variant="day" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
